import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Header } from '../components/shared/Header';
import { Footer } from '../components/landing/Footer';
import { SectionHeading } from '../components/shared/SectionHeading';

const AccessibilityPage: React.FC = () => {
  const { t } = useTranslation();
  const s = (key: string) => t(`accessibilityPage.sections.${key}`);
  const items = (key: string) => t(`accessibilityPage.sections.${key}`, { returnObjects: true }) as string[];

  return (
    <div className="page-shell">
      <Header />

      <section className="section-shell">
        <div className="section-container">
          <div className="surface-card-soft p-8 md:p-10">
            <Link to="/" className="mb-6 inline-block text-sm text-slate-500 hover:text-primary hover:underline">
              {t('accessibilityPage.backToHome')}
            </Link>
            <SectionHeading
              eyebrow={t('accessibilityPage.title')}
              title={t('accessibilityPage.title')}
              subtitle={t('accessibilityPage.subtitle')}
            />
          </div>
        </div>
      </section>

      <div className="section-container pb-20">
        <div className="mx-auto max-w-4xl space-y-6">
        <section className="surface-card p-6 md:p-8">
          <h2 className="mb-4 text-2xl font-bold text-ink">{s('goal.title')}</h2>
          <p className="leading-relaxed text-slate-700">{s('goal.text')}</p>
        </section>

        <section className="surface-card p-6 md:p-8">
          <h2 className="mb-4 text-2xl font-bold text-ink">{s('compliance.title')}</h2>
          <p className="mb-3 leading-relaxed text-slate-700">{s('compliance.text')}</p>
          <ul className="list-disc space-y-2 pl-6 text-slate-700">
            {(items('compliance.items') || []).map((item, i) => <li key={i}>{item}</li>)}
          </ul>
          <p className="mt-3 leading-relaxed text-slate-700">{s('compliance.limitation')}</p>
        </section>

        <section className="surface-card p-6 md:p-8">
          <h2 className="mb-4 text-2xl font-bold text-ink">{s('alternatives.title')}</h2>
          <p className="leading-relaxed text-slate-700">{s('alternatives.text')}</p>
        </section>

        <section className="surface-card p-6 md:p-8">
          <h2 className="mb-4 text-2xl font-bold text-ink">{s('contact.title')}</h2>
          <p className="leading-relaxed text-slate-700">{s('contact.text')}</p>
          <div className="mt-4 rounded-2xl border border-primary/10 bg-primary/5 p-4 text-sm text-slate-700 space-y-1">
            <p><strong>E-mail:</strong> <a href={`mailto:${s('contact.email')}`} className="text-primary underline">{s('contact.email')}</a></p>
            <p>{s('contact.responseTime')}</p>
          </div>
        </section>

        <section className="surface-card p-6 md:p-8">
          <h2 className="mb-4 text-2xl font-bold text-ink">{s('enforcement.title')}</h2>
          <p className="leading-relaxed text-slate-700">{s('enforcement.text')}</p>
        </section>

        <section className="surface-card p-6 md:p-8">
          <h2 className="mb-4 text-2xl font-bold text-ink">{s('technical.title')}</h2>
          <ul className="list-disc space-y-2 pl-6 text-slate-700">
            {(items('technical.items') || []).map((item, i) => <li key={i}>{item}</li>)}
          </ul>
        </section>

        <section className="surface-card p-6 md:p-8">
          <h2 className="mb-4 text-2xl font-bold text-ink">{s('date.title')}</h2>
          <p className="leading-relaxed text-slate-700">{s('date.text')}</p>
        </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AccessibilityPage;
